import { InputHTMLAttributes } from 'react';

import { Container } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  size?: number;
  isError?: boolean;
}

export const Input: React.FC<InputProps> = ({
  name,
  label,
  size,
  isError,
  ...rest
}) => {
  return (
    <Container error={isError}>
      <label htmlFor={name}>{label}</label>
      <input id={name} style={{ width: size }} {...rest} required />
    </Container>
  );
};
